import styled from '@emotion/styled';

const ChartContainer = styled('div')(`
  position: relative;
  & > td {
    font-size: 8px;
  }
`);

export default ChartContainer;
